<app-table [paginacion]="false" [columnas]="columnas" [datos]="datos">
</app-table>
